export default __webpack_public_path__ + "static/media/rabbit2.96a3e23e.gif";